import { render, staticRenderFns } from "./OtoCoupon.vue?vue&type=template&id=3b3538cc&scoped=true&"
import script from "./OtoCoupon.vue?vue&type=script&lang=js&"
export * from "./OtoCoupon.vue?vue&type=script&lang=js&"
import style0 from "./OtoCoupon.vue?vue&type=style&index=0&id=3b3538cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3538cc",
  null
  
)

export default component.exports